export const AW_BRIDGE_API_URL = process.env?.AWAPI_AWBRIDGE_URL || '/aw-api';
export const AW_BRIDGE_API_URL_AGRAPH = process.env?.AWAPI_AWBRIDGE_URL_AGRAPH || '/api/wealth/legacy/aw-api/v1';
export const PAGINATE_USER_ENTRIES = 'paginateUserEntries';
